import { OpenNewWidnowIcon } from '@synoptic/ui-kit/icons/react/open-new-widnow.js';
import { LinkButton } from '@synoptic/ui-kit/link-button/link-button.js';
import { Link } from '@/routes-utils/navigation.tsx';
import { regexHelpAction } from './regex-help-hint.css.ts';

export const REGEX_HINT_TITLE = 'What is a regex?';

export const REGEX_HINT_DESCRIPTION =
  'A search pattern that catches many wordings at once. Write it between slashes, like /(fed|fomc)/i';

// The field only accepts /pattern/flags, so the prompt has to ask for that form
const REGEX_PROMPT = `Write a regular expression for me.

My goal: <describe here what the pattern should match>

It filters a live news feed in a JavaScript app. Reply with one regular expression in /pattern/flags form, for example /\\b(fed|fomc)\\b/i, then explain in a sentence or two what it matches and what it skips.`;

const REGEX_PROMPT_URL = `https://chat.openai.com/?q=${encodeURIComponent(REGEX_PROMPT)}`;

export const RegexHelpAction = () => (
  <LinkButton
    asChild
    size="small"
    className={regexHelpAction}
    endIcon={<OpenNewWidnowIcon width={14} height={14} />}
  >
    <Link to={REGEX_PROMPT_URL} target="_blank">
      Generate regex with AI
    </Link>
  </LinkButton>
);
